/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why the rate stream terminated abnormally.
 * @export
 */
export const HotelRateStreamErrorCode = {
    NotFound: 'not_found',
    Unauthorized: 'unauthorized',
    Timeout: 'timeout',
    ImplFailure: 'impl_failure',
    Internal: 'internal'
} as const;
export type HotelRateStreamErrorCode = typeof HotelRateStreamErrorCode[keyof typeof HotelRateStreamErrorCode];


export function instanceOfHotelRateStreamErrorCode(value: any): boolean {
    for (const key in HotelRateStreamErrorCode) {
        if (Object.prototype.hasOwnProperty.call(HotelRateStreamErrorCode, key)) {
            if (HotelRateStreamErrorCode[key as keyof typeof HotelRateStreamErrorCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HotelRateStreamErrorCodeFromJSON(json: any): HotelRateStreamErrorCode {
    return HotelRateStreamErrorCodeFromJSONTyped(json, false);
}

export function HotelRateStreamErrorCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelRateStreamErrorCode {
    return json as HotelRateStreamErrorCode;
}

export function HotelRateStreamErrorCodeToJSON(value?: HotelRateStreamErrorCode | null): any {
    return value as any;
}

export function HotelRateStreamErrorCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): HotelRateStreamErrorCode {
    return value as HotelRateStreamErrorCode;
}

